module.exports = __webpack_public_path__ + "static/media/barrels.b29b8491.png";